import { EntityDescriptor } from "@crispico/foundation-react";
import { FieldType } from "@crispico/foundation-react/entity_crud/FieldType";

export class ObuCommandHistoryEntityDescriptor extends EntityDescriptor {

    constructor() {
        super({ name: "ObuCommandHistory" });
    }

    protected customize() {
        this.addFieldDescriptor({ name: "paramJson", type: FieldType.text })
    }
}
